import { Link } from "react-router-dom";

import type { Issue } from "../lib/api";
import { day } from "../lib/format";
import { SeverityBadge, SeverityIcon } from "./Badges";

export function IssueList({ issues, onResolve, onReopen, compact }: {
  issues: Issue[]; onResolve?: (i: Issue) => void; onReopen?: (i: Issue) => void; compact?: boolean;
}) {
  if (!issues.length) return <p className="empty">No issues. 🎉</p>;
  return (
    <ul className="issues">
      {issues.map((issue) => (
        <li key={issue.id} className="issue" data-testid="issue">
          <SeverityIcon severity={issue.severity} />
          <div className="issue-body">
            <p className="issue-summary">{issue.summary}</p>
            {!compact && (
              <p className="issue-meta">
                <SeverityBadge severity={issue.severity} />
                <span className="muted"> · {issue.check}</span>
                {issue.source_name && <span className="muted"> · {issue.source_name}</span>}
                {issue.run_id && <> · <Link to={`/imports/${issue.run_id}`}>import #{issue.run_id}</Link></>}
                {issue.document_id && <> · <Link to={`/documents/${issue.document_id}`}>open document</Link></>}
                <span className="muted"> · found {day(issue.detected_at)}</span>
                {issue.resolved_at && <span className="muted"> · resolved {day(issue.resolved_at)}</span>}
              </p>
            )}
          </div>
          {onResolve && !issue.resolved_at && (
            <button className="btn btn-sm" onClick={() => onResolve(issue)}>Mark resolved</button>
          )}
          {onReopen && issue.resolved_at && (
            <button className="btn btn-sm" onClick={() => onReopen(issue)}>Reopen</button>
          )}
        </li>
      ))}
    </ul>
  );
}
